import React from 'react';

// interface MessageProps {
//     message: string;
// }

function NotFoundComponent(){
    return (
        <>
            <h1>Page not found</h1>
        </>
    );
};

export default NotFoundComponent;